import type { ValueFormatterParams } from "ag-grid-community";

import { fDate } from "../utils/grid-helpers";

export const DateCellRenderer = (params: ValueFormatterParams<string | Date>) => {
  const v = params?.value as string | Date | undefined;
  if (!v) {
    return "";
  }
  if (v instanceof Date) {
    return v.toISOString().slice(0, 10);
  }
  // v is string
  return fDate(v);
};
